module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-about"
  }, [_c('header-prop', {
    staticClass: "header-prop-about",
    attrs: {
      "title": "Essential",
      "subtitle": "ingredients"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://vuejs.org",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/icon-vue.svg"),
      "width": "100"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://octobercms.com/",
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "october",
    attrs: {
      "src": require("../assets/icon-october.svg"),
      "width": "70"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://developer.apple.com/ios/",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/icon-ios.svg"),
      "width": "100"
    }
  })]), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://developer.android.com/studio/index.html",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/icon-android.svg"),
      "width": "100"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://facebook.github.io/react-native/",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/icon-react.svg"),
      "width": "100"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://firebase.google.com/",
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "grayscale",
    attrs: {
      "src": require("../assets/icon-firebase.svg"),
      "width": "100"
    }
  })])]), _vm._v(" "), _c('content-project-list-section'), _vm._v(" "), _c('div', {
    staticClass: "particle-wrapper"
  }, [_c('vue-particles', {
    staticClass: "particle-main",
    attrs: {
      "color": "#A01A37",
      "particleOpacity": 5,
      "particlesNumber": 15,
      "shapeType": "edge",
      "particleSize": 8.5,
      "linesColor": "#dedede",
      "linesWidth": 1,
      "lineLinked": true,
      "lineOpacity": 0.4,
      "linesDistance": 150,
      "moveSpeed": 3,
      "moveDirection": 'bottom',
      "hoverEffect": true,
      "hoverMode": "grab",
      "clickEffect": true,
      "clickMode": "push"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "hero section-about",
    attrs: {
      "id": "section-about"
    }
  }, [_c('div', {
    staticClass: "hero-body"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "columns is-gapless is-centered is-multiline"
  }, [_c('div', {
    staticClass: "column is-10 is-content has-text-left",
    attrs: {
      "data-aos": "fade-in",
      "data-aos-once": "true"
    }
  }, [_c('p'), _vm._m(0), _vm._v(" "), _c('p'), _vm._v(" "), _c('br'), _vm._v(" "), (false) ? _c('a', {
    staticClass: "button is-medium",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.$scrollTo('#carousel-slick', {
          offset: -30
        })
      }
    }
  }, [_vm._v("Run")]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')]), _vm._v(" "), (false) ? _c('div', {
    staticClass: "column is-4 is-card has-text-left",
    staticStyle: {
      "overflow": "hidden"
    }
  }, [_c('div', {
    staticClass: "card",
    attrs: {
      "data-aos": "fade-left",
      "data-aos-once": "true"
    }
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "card-content",
    staticStyle: {
      "background-color": "lightgray"
    }
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._v("\n                    Bzzz."), _c('br'), _vm._v(" "), _c('a', [_vm._v("#metaphorical")]), _vm._v(" "), _c('a', [_vm._v("#concepts")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('small', [_vm._v(_vm._s('11:09 PM - 1 Jan 2017'))])])])])]) : _vm._e()])])])])], 1), _vm._v(" "), _c('carousel-slick'), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "relative",
      "z-index": "1"
    }
  }, [_c('a', {
    staticClass: "next-section next-blue",
    attrs: {
      "rel": "nofollow",
      "href": "#portfolio"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.$scrollTo('#section-services', {
          offset: 0
        })
      }
    }
  }, [_c('i', {
    staticClass: "material-icons",
    staticStyle: {
      "font-size": "1.5em"
    }
  }, [_vm._v("keyboard_arrow_down")])])]), _vm._v(" "), _c('div', {
    staticClass: "section-services",
    attrs: {
      "id": "section-services"
    }
  }, [_c('section', {
    staticStyle: {
      "position": "relative",
      "width": "100%"
    }
  }, [_c('div', {
    attrs: {
      "id": "services-bg"
    }
  }, [_vm._v("\n           \n      ")]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "services-cover"
    }
  }, [_vm._v("\n           \n      ")]), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), (false) ? _c('div', {
    staticClass: "container",
    staticStyle: {
      "margin-top": "80px",
      "margin-bottom": "0px"
    }
  }, [_vm._m(5)]) : _vm._e(), _vm._v(" "), (false) ? _c('div', {
    staticClass: "container"
  }, [_vm._m(6)]) : _vm._e(), _vm._v(" "), _vm._m(7)])]), _vm._v(" "), (false) ? _c('section-comment') : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "text-faded has-text-centered"
  }, [_c('br'), _vm._v(" "), _c('br'), _vm._v("\n                  hello, we are "), _c('span', {
    staticClass: "color-orange"
  }, [_vm._v("passionate")]), _vm._v(" "), _c('span', {
    staticClass: "color-gray"
  }, [_vm._v("\\\\n")]), _vm._v(" "), _c('br'), _c('span', [_c('b', [_c('a', {
    attrs: {
      "href": "/contact",
      "target": "_blank"
    }
  }, [_c('u', {
    staticStyle: {
      "border-bottom": "1px solid #fc0",
      "text-decoration": "none",
      "color": "white"
    }
  }, [_vm._v("coders")])]), _vm._v(" &\n                      "), _c('a', {
    attrs: {
      "href": "/contact",
      "target": "_blank"
    }
  }, [_c('u', {
    staticStyle: {
      "border-bottom": "1px solid #A01A37",
      "text-decoration": "none",
      "color": "white"
    }
  }, [_vm._v("designers")])])])]), _vm._v(",\n                  "), _vm._v(" "), _c('br'), _vm._v("specializing "), _c('span', {
    staticClass: "color-red"
  }, [_vm._v("minimal")]), _vm._v(" UI / UX design.\n                  "), _c('br'), _vm._v("tayloring "), _c('span', {
    staticClass: "color-gray"
  }, [_vm._v("bespoke")]), _vm._v(" software solutions.\n                  "), _c('br'), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "margin-left": "auto",
      "margin-right": "auto"
    },
    attrs: {
      "ng-cloak": ""
    }
  }, [_c('span', {
    staticClass: "typewriter-start typewriter"
  }, [_c('div', {
    staticStyle: {
      "border-width": "3px"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#F0A202"
    }
  }, [_vm._v(">:")]), _vm._v("  \n                      ")])])]), _vm._v(" "), _c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-image"
  }, [_c('figure', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "width": "300px",
      "margin": "0 auto"
    },
    attrs: {
      "src": require("../assets/logo.svg"),
      "width": "150",
      "alt": "Image"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "media"
  }, [_c('div', {
    staticClass: "media-left"
  }, [_c('figure', {
    staticClass: "image is-48x48"
  }, [_c('img', {
    staticStyle: {
      "border-radius": "30px"
    },
    attrs: {
      "src": "http://via.placeholder.com/96/ffffff/000000",
      "alt": "Image"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "media-content"
  }, [_c('p', {
    staticClass: "title is-4"
  }, [_vm._v("noctorus")]), _vm._v(" "), _c('p', {
    staticClass: "subtitle is-6"
  }, [_c('span', {
    staticClass: "color-orange"
  }, [_vm._v(">:")]), _vm._v(" "), _c('span', {
    staticClass: "color-gray"
  }, [_vm._v("= nocturnal")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container",
    staticStyle: {
      "padding-top": "50px"
    }
  }, [_c('div', {
    staticClass: "columns is-gapless"
  }, [_c('div', {
    staticClass: "column has-text-centered"
  }, [_c('h2', {
    staticClass: "title"
  }, [_vm._v("core")]), _vm._v(" "), _c('hr', {
    staticClass: "center"
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "columns is-centered is-gapless"
  }, [_c('div', {
    staticClass: "column is-2 has-text-centered",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-once": "true"
    }
  }, [_c('i', {
    staticClass: "fa fa-4x fa-circle-o color-orange",
    staticStyle: {
      "padding": "15px",
      "margin-top": "30px"
    },
    attrs: {
      "data-sr": "wait 0.0s, move 0px scale up 20%, over 0.6s"
    }
  }), _vm._v(" "), _c('h3', [_vm._v("minimal")])]), _vm._v(" "), _c('div', {
    staticClass: "column is-2 has-text-centered",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-once": "true"
    }
  }, [_c('i', {
    staticClass: "fa fa-4x fa-hand-spock-o color-blue",
    staticStyle: {
      "padding": "15px",
      "margin-top": "30px"
    },
    attrs: {
      "data-sr": "wait 0.0s, move 0px scale up 20%, over 0.6s"
    }
  }), _vm._v(" "), _c('h3', [_vm._v("passionate")])]), _vm._v(" "), _c('div', {
    staticClass: "column is-2 has-text-centered",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-once": "true"
    }
  }, [_c('i', {
    staticClass: "fa fa-4x fa-cube color-red",
    staticStyle: {
      "padding": "15px",
      "margin-top": "30px"
    },
    attrs: {
      "data-sr": "wait 0.0s, move 0px scale up 20%, over 0.6s"
    }
  }), _vm._v(" "), _c('h3', [_vm._v("extensible")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns is-gapless"
  }, [_c('div', {
    staticClass: "column has-text-centered"
  }, [_c('i', {
    staticClass: "fa fa-4x fa-gear",
    staticStyle: {
      "color": "#bbb"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns is-gapless"
  }, [_c('div', {
    staticClass: "column has-text-centered"
  }, [_c('h2', {
    staticClass: "title"
  }, [_vm._v("stack")]), _vm._v(" "), _c('hr', {
    staticClass: "center"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container",
    staticStyle: {
      "margin-top": "50px",
      "padding-bottom": "50px"
    }
  }, [_c('div', {
    staticClass: "columns is-centered is-gapless"
  }, [_c('div', {
    staticClass: "column is-4 has-text-centered",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-once": "true"
    }
  }, [_c('i', {
    staticClass: "fa fa-4x fa-cubes color-gray",
    staticStyle: {
      "padding": "15px"
    },
    attrs: {
      "data-sr": "wait 0.0s, move 0px scale up 20%, over 0.6s"
    }
  }), _vm._v(" "), _c('h3', [_vm._v("engine")])])]), _vm._v(" "), _c('div', {
    staticClass: "columns is-centered is-gapless",
    attrs: {
      "data-aos": "fade-right",
      "data-aos-once": "true"
    }
  }, [_c('div', {
    staticClass: "column is-3 is-6-tablet is-3-desktop has-text-left",
    staticStyle: {
      "padding": "30px",
      "padding-top": "0"
    }
  }, [_c('br'), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('ul', [_c('li', [_vm._v("Brand / corporate identity")]), _vm._v(" "), _c('li', [_vm._v("Collateral design")]), _vm._v(" "), _c('li', [_vm._v("UI / UX design")]), _vm._v(" "), _c('li', [_vm._v("App development")]), _vm._v(" "), _c('li', [_vm._v("Web solutions")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1441d0dd","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/About.vue
// module id = 801
// module chunks = 1